import { gql } from "graphql-request"

export const SIGNUP = gql`
  mutation SIGNUP(
    $phone: String!
    $country: String!
    $password: String!
    $loginOnly: Boolean
  ) {
    signup(
      phone: $phone
      country: $country
      password: $password
      loginOnly: $loginOnly
    ) {
      status
      error
      data {
        id
        username
        phone
        country
        token
        twoFactorEnabled
      }
    }
  }
`
